import {request} from './request'
const artistApi ={
  // 首页模块-新闻列表--获取有头像的人才列表
  getPicList:params=>{
    let params2={
      page:params.page || 1,
      pageSize:params.pageSize|| 6,
      firstCode:params.firstCode || "",
      channels_id:params.channels_id || '',
      keywords:params.keywords || '',
      city:params.city || ''
    }
    return request({url: '/ArtistApi/GetListHasHead',params:params2});
  },

  //置顶随机的有图片的人才
  getPicListTop:params=>{ 
    return request({url:"/ArtistApi/GetListHasHeadIsTop?"+new Date().getTime(),params:params})
  },

  GetListHasHeadRecommend:params=>{
    return request({ url: "/ArtistApi/GetListHasHeadRecommend?" + new Date().getTime(), params: params})
  },


  // 人才列表
  getNormalList:params=>{
    let params2={
      page:params.page || 1,
      pageSize:params.pageSize || 8,
    }
    return request({url: '/ArtistApi/GetList',params:params2});
  },

  // 筛选的人才列表
  getList:params=>{
    let params2={
      page:params.page || 1,
      pageSize:params.pageSize|| 8,
      firstCode:params.firstCode || "",
      channels_id:params.channels_id || '',
      keywords:params.keywords || '',
      city:params.city || ''
    }
    return request({url: '/ArtistApi/GetSearchPageList',params:params2});
  },
  //单一内容
  getOneById:params=>{
    return request({url: '/ArtistApi/GetById',params:params,});
  },

  getChart:params=>{
    return request({url:"/ArtistApi/GetKnowledgeGraph",params})
  },

  getWorks: params => request({url:"/ArtistApi/GetArtistOpus",params})
}

export default artistApi